import { Box, Text } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";

function GithubCalender() {
  return (
    <Box width={"100%"} textAlign={"center"} margin={"auto"}>
      <Box>
        <Text
          mb={"60px"}
          color={"#FFB6C1"}
          mt={20}
          textDecoration={"underline"}
          fontSize={{ base: "30px", md: "45px", lg: "60px" }}
        >
          Github Calendar
        </Text>
      </Box>
      <GitHubCalendar
      style={{width:"90%",margin:"auto"}}
      color={"#FFB6C1"}
      hideTotalCount
      hideColorLegend
      username="imrangadwal10" />
      <ReactTooltip delayShow={20} html />
    </Box>
  );
}

export default GithubCalender;
